// extracted by mini-css-extract-plugin
export default {"control":"control_control__wgKO9","button":"control_button__lt3EZ"};